import { render, staticRenderFns } from "./ModalCadastroDiario.vue?vue&type=template&id=2036c72e"
import script from "./ModalCadastroDiario.vue?vue&type=script&lang=js"
export * from "./ModalCadastroDiario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports